import type { Stage } from '../../types';

export const pregnancy2: Stage = {
  id: 'pregnancy-2',
  key: '2',
  title: '妊娠中期',
  subtitle: '安定期を味方に',
  weeks: '14–27週',
  description:
    'つわりが落ち着く人も多い、準備の黄金期です。買い物や手続きを進め、体も動かしましょう。',
  mindCards: [
    {
      id: 'm1',
      title: '安定期を味方に',
      body: '無理のない範囲で体を動かし、リズムを取り戻しましょう。',
      type: 'body',
    },
    {
      id: 'm2',
      title: '段取りを整える',
      body: '赤ちゃんの成長を感じながら、買い物や手続きを計画的に進めます。',
      type: 'mind',
    },
    {
      id: 'm3',
      title: '買い物を楽しむ',
      body: 'ベビー用品のリストを作り、必要なものから揃えていきましょう。',
      type: 'life',
    },
    {
      id: 'm4',
      title: '出産後の役割を話す',
      body: 'パートナーと一緒に用品を選び、産後の分担を話し合いましょう。',
      type: 'mind',
    },
    {
      id: 'm5',
      title: '胎動を感じる',
      body: '小さな動きに気づくと、リアリティが増します。急な減少があれば相談を。',
      type: 'body',
    },
    {
      id: 'm6',
      title: '職場との調整',
      body: '安定期を機に、産休前の業務引き継ぎを話し始めましょう。',
      type: 'partner',
    },
    {
      id: 'm7',
      title: '鉄分・カルシウムを意識',
      body: '赤身の肉・魚・小松菜などで鉄分を、牛乳・ヨーグルト・小松菜などでカルシウムを補いましょう。',
      type: 'body',
    },
    {
      id: 'm8',
      title: '産後のサポートを先に',
      body: '産後ケア事業や実家のサポート、家事代行などを検討しておきましょう。',
      type: 'life',
    },
  ],
  checklist: [
    { id: 'c1', text: '妊婦健診の日程を確認する', category: 'hospital', note: '中期は約4週に1回のペースが多い' },
    { id: 'c2', text: 'ベビー用品の優先リストを作る', category: 'shopping', note: '必須・推奨・あれば便利に分類' },
    { id: 'c3', text: 'ベビー服のサイズ感を調べる', category: 'shopping', note: '新生児〜50〜60cmを中心に' },
    { id: 'c4', text: 'ベビー部屋や寝場所の計画を立てる', category: 'life', note: '寝室・リビングのどちらがいいか検討' },
    { id: 'c5', text: '出産予定日を確認し、職場に報告する', category: 'admin', note: '会社の規定に応じて書類を提出' },
    { id: 'c6', text: '健康保険の高額療養費制度を確認する', category: 'admin', note: '限度額適用認定証の取得も視野に' },
    { id: 'c7', text: '里帰り出産 or 産院入院の方針を決める', category: 'admin', note: '交通手段や家族のサポートを含めて' },
    { id: 'c8', text: 'ペット・見舞い対策などを確認する', category: 'life', note: '退院後の環境もイメージ' },
    { id: 'c9', text: 'マタニティ写真や日記を始める', category: 'life', note: '毎日でなくても記録に残す' },
    { id: 'c10', text: '体を動かす時間を確保する（産院の指導に従う）', category: 'body', note: '無理のない運動・ストレッチ' },
    { id: 'c11', text: '食事のバランスと体重増加を見る', category: 'body', note: 'BMIに応じた推奨体重増加量を目安に（個人差あり）' },
    { id: 'c12', text: 'パートナーに産後のサポートを確認する', category: 'partner', note: '夜間・家事・買い物の分担' },
    { id: 'c13', text: '出産に関する本や講座を探す', category: 'mind', note: '夫婦で受講できる講座もおすすめ' },
    { id: 'c14', text: 'マタニティウェアを揃える', category: 'shopping', note: 'お腹に優しい素材を選ぶ' },
    { id: 'c15', text: 'ベビーカーやチャイルドシートを比較検討する', category: 'shopping', note: '店舗で実物を確認する' },
    { id: 'c16', text: '出産費用の目安を産院に確認する', category: 'admin', note: '個室・オプションも含めて聞く' },
    { id: 'c17', text: '哺乳瓶や母乳関連グッズを調べる', category: 'shopping', note: '授乳・搾乳の選択肢を知る' },
    { id: 'c18', text: 'マタニティマークを身につける', category: 'life', note: '電車や施設で使う' },
    { id: 'c19', text: '胎動の変化に気づく', category: 'body', note: '18〜22週頃から感じ始める人が多い' },
    { id: 'c20', text: '友人・先輩ママと情報交換する', category: 'mind', note: '同じ時期の人と話すと安心' },
    { id: 'c21', text: '職場の業務引き継ぎを意識する', category: 'admin', note: '優先順位や担当者を整理' },
    { id: 'c22', text: '出産後のサポート体制を家族と話す', category: 'partner', note: '実家やヘルパーの検討も' },
    { id: 'c23', text: '出産施設を決め、分娩予約をする', category: 'hospital', note: '里帰り出産も含め、早めに予約が安心です' },
    { id: 'c24', text: '妊婦歯科健診を受ける', category: 'hospital', note: '妊娠16〜30週頃が目安。虫歯や歯周病は早産リスクを高めます' },
    { id: 'c25', text: 'ベビー用品の本格的準備を始める', category: 'shopping', note: '短肌着・長肌着各4〜5枚、寝具、おむつ、入浴用品などを中心に' },
    { id: 'c26', text: '産後ケア事業（宿泊・デイ・訪問）の利用を検討する', category: 'admin', note: '新潟市の例。原則妊娠8か月から利用日の10日前までに申請が必要です。' },
    { id: 'c27', text: '国民健康保険・国民年金の産前産後免除を申請する', category: 'admin', note: '出産予定日の6か月前から届出可能。年金受給額は減りません。' },
    { id: 'c28', text: '適度な運動を始める（医師の許可の上で）', category: 'body', note: 'ウォーキング・マタニティヨガ・スイミングなど' },
    { id: 'c29', text: '水銀を多く含む魚の摂取に注意する', category: 'body', note: 'サケ・アジ・サバ・ツナ缶は心配なし。キダイ・マカジキ・ミナミマグロ・金目鯛は量を控えめに' },
    { id: 'c30', text: '体重増加の目安を確認する', category: 'body', note: '自身のBMIに応じた推奨体重増加量を目安に（一般論）' },
    { id: 'c31', text: '保育施設・子育て支援をリサーチする', category: 'admin', note: '産後の仕事復帰を見据え、ファミリー・サポート・センターなども確認（新潟市の例）' },
    { id: 'c32', text: 'パートナーと家事分担を可視化する', category: 'partner', note: 'ゴミ出し・洗濯・家電の使い方など、妊娠中から共有' },
  ],
  shopping: [
    {
      id: 's1',
      name: 'マタニティウェア',
      priority: 'should',
      timing: '中期から',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '伸縮性のある素材を選ぶ',
    },
    {
      id: 's2',
      name: 'ベビー肌着（短肌着・長肌着）',
      priority: 'must',
      timing: '中期から',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '新生児サイズ50〜60cmを各4〜5枚',
    },
    {
      id: 's3',
      name: 'おむつ少量セット（新生児サイズ）',
      priority: 'must',
      timing: '後期から',
      priceYenMin: 1500,
      priceYenMax: 5000,
      note: '試してから大量購入がおすすめ',
    },
    {
      id: 's4',
      name: 'ベビー用保湿剤・沐浴剤',
      priority: 'should',
      timing: '中期から',
      priceYenMin: 1500,
      priceYenMax: 4000,
      note: '低刺激・無添加を確認',
    },
    {
      id: 's5',
      name: '授乳ブラ',
      priority: 'should',
      timing: '後期から',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '楽な着け心地を優先',
    },
    {
      id: 's6',
      name: 'ボディピロー',
      priority: 'nice',
      timing: '中期から',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: '横向き寝をサポート',
    },
    {
      id: 's7',
      name: 'ベビーカー',
      priority: 'should',
      timing: '中期〜',
      priceYenMin: 20000,
      priceYenMax: 80000,
      note: '店舗で実際に試すのがおすすめ',
    },
    {
      id: 's8',
      name: 'チャイルドシート（0歳児対応）',
      priority: 'must',
      timing: '後期',
      priceYenMin: 20000,
      priceYenMax: 50000,
      note: '新生児から使えるタイプを選ぶ。退院時に必要',
    },
    {
      id: 's9',
      name: 'ベビー布団・ベビーベッド',
      priority: 'must',
      timing: '後期',
      priceYenMin: 15000,
      priceYenMax: 60000,
      note: '添い寝かベッドかを決める。使用期間が短い場合はレンタルも',
    },
    {
      id: 's10',
      name: '授乳クッション',
      priority: 'should',
      timing: '後期〜産後',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '産後の腰の負担軽減に',
    },
    {
      id: 's11',
      name: '抱っこ紐',
      priority: 'should',
      timing: '後期〜産後',
      priceYenMin: 3000,
      priceYenMax: 15000,
      note: '新生児対応か確認',
    },
    {
      id: 's12',
      name: '産褥ショーツ',
      priority: 'must',
      timing: '後期',
      priceYenMin: 2000,
      priceYenMax: 5000,
      note: '産後の大きめサイズを3〜5枚',
    },
    {
      id: 's13',
      name: 'ベビーバス・沐浴セット',
      priority: 'should',
      timing: '中期〜後期',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '湯温計・タオル・低刺激洗剤などをセットで',
    },
    {
      id: 's14',
      name: 'マタニティブラ・授乳ブラ',
      priority: 'should',
      timing: '中期から',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '楽な着け心地を優先。産後も使えるデザインを',
    },
  ],
  warnings: [
    { id: 'w1', label: '规律のある腹痛や出血', level: 'urgent' },
    { id: 'w2', label: '破水の可能性がある', level: 'urgent' },
    { id: 'w3', label: '頭痛や視界の異常', level: 'urgent' },
    { id: 'w4', label: '手のしびれ', level: 'watch' },
    { id: 'w5', label: '足のむくみ', level: 'watch' },
    { id: 'w6', label: '体重の急激な増加', level: 'watch' },
    { id: 'w7', label: '胎動の減少', level: 'watch' },
    { id: 'w8', label: '動悸や息切れがひどい', level: 'watch' },
    { id: 'w9', label: '尿漏れや痛み', level: 'watch' },
    { id: 'w10', label: '目のチカチカ・強い頭痛', level: 'watch' },
    { id: 'w11', label: '胎動の急激な減少', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '一緒にベビー用品を買いに行く' , detail: '必須品（肌着・おむつ・布団・チャイルドシート）から一緒に買う。可愛い物は後回しで予算を守る。'},
    { id: 'p2', text: '出産後の役割分担をリスト化する' , detail: '産後の家事・夜間対応を表にし、パパが主担当の欄を決める。実家サポートの有無も書く。'},
    { id: 'p3', text: '産院の見学に同行する' , detail: '産院見学に同行し、立ち会いルール・入院の流れ・駐車場をメモする。'},
    { id: 'p4', text: 'マタニティフォトの撮影を手伝う' , detail: '撮影日の移動・荷物・休憩を手伝う。体調優先で無理のないプランに。'},
    { id: 'p5', text: '夜間の家事を引き受ける' , detail: '夕食後の洗い物・お風呂掃除など、夜の家事を固定で引き取る。'},
    { id: 'p6', text: '出産費用の支払い準備をする' , detail: '出産育児一時金や直接支払制度を調べ、貯金・支払いタイミングを共有する。'},
    { id: 'p7', text: '育児本や講座を一緒に学ぶ' , detail: '育児本や両親学級を一緒に1つ選ぶ。学んだことを「自分がやること」に落とす。'},
    { id: 'p8', text: 'ママの体調を毎日確認する' , detail: '毎朝・毎晩、体調と胎動の感じを短く確認。変化があれば一緒に産院へ連絡。'},
    { id: 'p9', text: '産後の家事分担を妊娠中から練習する' , detail: '洗濯・ゴミ出しなど産後に続く家事を、妊娠中からパパ主導で回す練習をする。'},
  ],
  tips: [
    {
      id: 't1',
      title: '安定期だからと無理しない',
      body: 'つわりが落ち着いても、体は大きく変化しています。旅行や引っ越しは計画的に、無理のない範囲で。',
    },
    {
      id: 't2',
      title: 'ベビー用品は「必須」からそろえる',
      body: '可愛いものが多くて目移りしがち。まずは肌着・おむつ・布団・チャイルドシートなど必須品から。',
    },
    {
      id: 't3',
      title: '胎動は個人差が大きい',
      body: '初産婦だと20週を過ぎてから感じることも。急に減ったり止まったりしたら産院へ連絡を。',
    },
    {
      id: 't4',
      title: '職場報告は書面も準備',
      body: '産休・育休の申請書や医師の診断書が必要な場合があるので、人事担当に必要書類を確認しておくと安心。',
    },
    {
      id: 't5',
      title: '体重増加はBMIに応じて',
      body: '妊娠中期は通常より+250kcal、末期・授乳期は+450kcalが目安。ただし、BMI別の推奨体重増加量を守るのが大切です。',
    },
    {
      id: 't6',
      title: '鉄分・カルシウムを意識',
      body: '妊娠中は貧血になりやすく、胎児の骨や歯の形成にもカルシウムが必要。赤身の肉・魚・小松菜・牛乳・ヨーグルトなどで補いましょう。',
    },
    {
      id: 't7',
      title: '妊婦歯科健診は安定期に',
      body: '妊娠16〜30週頃に1回無料で受けられます。歯周病は早産や低出生体重児のリスクを高めるため、早めに受診しましょう。',
    },
    {
      id: 't8',
      title: '産後ケアは早めに検討',
      body: '新潟市の産後ケア事業は宿泊型・デイ型・訪問型があります。家族等から十分な援助が受けられない場合は、妊娠8か月から申請可能です。',
    },
  ],
  adminGuide: [
    {
      id: 'a1',
      title: '産休取得の申請',
      body: '出産予定日の6週前（多胎の場合は14週前）から取得できます。会社の規定に沿って申請書と医師の診断書を提出しましょう。',
      when: '妊娠中期〜後期',
    },
    {
      id: 'a2',
      title: '高額療養費制度',
      body: '1か月の医療費が高額になった場合、健康保険の限度額を超えた分が還付されます。「限度額適用認定証」を事前に取得すると窓口負担が軽減されます。',
      when: '健診が増える中期以降',
    },
    {
      id: 'a3',
      title: 'ベビー用品の受け取りサービス',
      body: '自治体や保健センターでベビー服・おむつ・ミルクなどの無償配布・助成がある場合も。産前産後の支援制度を市町村HPで確認しましょう。',
      when: 'いつでも確認',
    },
    {
      id: 'a4',
      title: '里帰り出産の手続き',
      body: '実家のある自治体で妊婦健診を受ける場合、転出届や健康保険の手続きが必要なことがあります。産院も紹介状が必要な場合があるので確認を。',
      when: '里帰りを決めたら',
    },
    {
      id: 'a5',
      title: '育児休業給付金',
      body: '育休中は雇用保険から給付金が支給されます。取得期間や賃金の条件を確認し、会社と調整を。',
      when: '産休取得前に計画',
    },
    {
      id: 'a6',
      title: '出産施設の決定と分娩予約',
      body: '里帰り出産を含め、出産する病院を早めに決めて分娩予約を行いましょう。人気の施設は予約が埋まりやすいです。',
      when: '妊娠中期の早い段階まで',
    },
    {
      id: 'a7',
      title: '妊婦歯科健診',
      body: '妊娠中は虫歯や歯周病が進みやすく、早産のリスクも高まります。母子健康手帳交付を受けた妊婦は妊娠中に1回無料で受診できます。',
      when: '妊娠16〜30週頃',
    },
    {
      id: 'a8',
      title: '国民健康保険・国民年金の産前産後免除',
      body: '産前産後期間の保険料が免除・軽減されます。年金受給額は減りません。出産予定日の6か月前から届出可能です。',
      when: '妊娠中期〜出産後',
    },
    {
      id: 'a9',
      title: '産後ケア事業の利用申請',
      body: '新潟市では宿泊型・デイ型・訪問型の産後ケアがあります。原則、妊娠8か月から利用日の10日前までに申請が必要です（他自治体により異なります）。',
      when: '妊娠中期〜後期',
    },
    {
      id: 'a10',
      title: '妊産婦医療費助成の申請',
      body: '新潟市に住所がある妊産婦を対象に、医療費の一部負担金を除いた額を助成。受給資格認定日から助成期間が始まるため早めに申請してください。',
      when: '母子健康手帳交付後すぐ',
    },
  ],
  exercises: [
    {
      id: 'ex1',
      title: '妊娠全期向けワークアウト（15分）',
      durationMin: 15,
      url: 'https://www.youtube.com/watch?v=zmUJWKM98hM',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '安定期に入ったら、全身をバランスよく動かしましょう。',
      level: 'moderate',
    },
    {
      id: 'ex2',
      title: '妊婦さん向け全身ワークアウト（25分）',
      durationMin: 25,
      url: 'https://www.youtube.com/watch?v=Wlu6HsO-pEM',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '少し長めの全身運動。体力に合わせて休憩を入れながら。',
      level: 'moderate',
    },
    {
      id: 'ex3',
      title: 'アドリエンの妊婦ヨガ',
      durationMin: 22,
      url: 'https://www.youtube.com/watch?v=-3bvlFKeLRE',
      channel: 'アドリエンのヨガ',
      note: '呼吸を深め、心と体のつながりを感じるヨガ。リラックスにもおすすめ。',
      level: 'gentle',
    },
  ],
};
